
export type TableBtn = {
  type: TableBtnType,
  disabled?: boolean
}


// string[] é usado para certos items ocuparem mais de uma linha , ex sinais vitais tipo de dor
export type TableItemValue = null | string | string[]| number | Date | boolean | TableBtn[];

export type TableDataItem = Record<string , TableItemValue>;

export const tablesBtnsEditRemove: TableBtn[] = [{
  type: 'edit'
} , {
  type: 'remove'
}]

export type TableBtnType = 'add' | 'edit' | 'remove' | 'view' | 'upload'

export type TableBtnRowClick = { item: TableDataItem, btn: TableBtnType }

export const typeToIconMap = {
  add: 'add_circle',
  view: 'remove_red_eye',
  edit: 'edit',
  remove: 'cancel',
  upload: 'file_upload'
} as const

export const typeToCssClassMap = {
  add: 'has-background',
  view: 'has-background',
  edit: '',
  remove: '',
  upload: ''
}

export type TableColumnTypes = 'value' // datas strings ou numeros
  | 'check' // checkboxs
  | 'btn'  // um botao
  | 'radio'  // select radios
  | 'btns' //multiplos botoes horizontalmente dispostos
  | 'multiple-values' // valores que ocupam multiplas linhas , cada valor ocupando uma

export type TableColumn = {
  key: string;
  name: string;
  type: TableColumnTypes;
  options?: {
    valueType?: 'Date' | 'string' | 'number'
    btnType?: TableBtnType;
    btnsTypes?: TableBtnType[];
    btnDisabled? : Record<TableBtnType , boolean>;
    inputUnique?: boolean // se tabela só permite uma linha marcada por vez nessa coluna, padrao = true
    inputLabelKey?: string // se tiver, usa a prop [inputKeyLabel] do objeto para mostrar na celula com o input
    widthUnit?: 'px' | 'proportional';
    width?: number;
    position?: 'center' | 'start' | 'end',
    textTransform?: 'capitalize' | 'uppercase' | 'lowercase';
  },
  width?: string;
  columnAction?: 'none' | 'add' //se coluna vai ter um botão de acão no header
}

